export default "__VITE_ASSET__BLt8OpTi__"